import { createFileRoute, redirect } from '@tanstack/react-router'
import { RequireAuth } from '@dss/auth'
import { DistributorsListScreen } from '../features/distributors/DistributorsListScreen'
import { redirectIfNotPlatformAdmin } from '../lib/platformAdminGuard'

/** `/distributors` — список тенантов платформы (PA-4, D16 §5 / §6).
 *
 *  Файл назван `distributors.index.tsx`, а НЕ `distributors.tsx` — иначе
 *  TanStack Router сделает `distributors` parent для `distributors.$id` и
 *  потребует `<Outlet />` (тот же flatten-паттерн, что и для `orders.*`
 *  / `territories.*`).
 *
 *  Permission-gating: route-level redirect на /dashboard, если в JWT нет
 *  is_platform_admin=true. Дополнительно сам экран проверяет
 *  platform.distributors.view и показывает warning Banner, если permission'а
 *  нет (для PA-юзеров, у которых забыли проставить permission в KC). */
export const Route = createFileRoute('/distributors/')({
  beforeLoad: () => {
    redirectIfNotPlatformAdmin(redirect)
  },
  component: DistributorsListRoute,
})

function DistributorsListRoute() {
  return (
    <RequireAuth>
      <DistributorsListScreen />
    </RequireAuth>
  )
}
